import React, { useCallback, useEffect, useRef, useState } from "react";
import "./userProfile.css";
import { useParams, useNavigate } from "react-router-dom";
import apiClient from "../../../api/apiClient";

const UserProfile = ({ userId, setHeaderTitle }) => {
    const { id } = useParams();
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [profilePicture, setProfilePicture] = useState("");
    const [friends, setFriends] = useState([]);
    const [licenses, setLicenses] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchUserInfo() {
            try {
                // Fetch user info
                const response = await apiClient.get(`/user/get-user-license-info`, {
                    headers: {
                        id: id,
                    },
                });
                const data = await response.data;
                setFirstName(data.firstName);
                setLastName(data.lastName);
                setEmailAddress(data.email);
                setProfilePicture(data.profilePic);

                // Store all licenses in the state variable
                setLicenses(data.licenses || []);
                setHeaderTitle(data.firstName + " " + data.lastName);

            } catch (error) {
                console.error("Error:", error);
            }
        }

        // Call the async function
        fetchUserInfo();
    }, [id]);

    // const addFriend = async (event) => {
    // 	event.preventDefault();
    // 	const response = await apiClient.post(`/user/request-friend`, {
    // 		friendId: id,
    // 		userId: userId,
    // 	});
    // 	setPendingFriends((prevPendingFriends) => [...prevPendingFriends, id]);
    // };

    // //delete friend
    // const deleteFriend = async (friendId) => {
    // 	if (window.confirm("Are you sure you want to remove this friend?")) {
    // 		const response = await apiClient.post(`/user/delete-friend`, {
    // 			friendId: friendId,
    // 			userId: userId,
    // 		});
    // 		window.location.reload();
    // 	}
    // };

    // //accept friend request
    // const acceptFriend = async (friendId) => {
    // 	apiClient
    // 		.post(`/user/accept-friend`, {
    // 			friendId: friendId,
    // 			userId: userId,
    // 		})
    // 		.then(() => {
    // 			window.location.reload();
    // 		});
    // };

    // //decline friend Request
    // const declineFriend = async (friendId) => {
    // 	const response = await apiClient.post(`/user/decline-friend`, {
    // 		friendId: friendId,
    // 		userId: userId,
    // 	});
    // 	window.location.reload();
    // };

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await apiClient.post(`/user/upload-profile-pic`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            setProfilePicture(response.data.imageUrl);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    return (
        <div className="UserProfileContainer">
            <div className="social-links fade-down">
                <div className="basic-info">
                    <div className="top-portion-user-profile">
                        <label htmlFor="file-input">
                            {userId === id ? (
                                <>
                                    {!profilePicture && (
                                        <img
                                            src="/ProfilePicDefault.svg"
                                            alt="Profile"
                                            className="profile-pic-container"
                                            style={{ cursor: "pointer" }}
                                        />
                                    )}
                                    {profilePicture && (
                                        <div className="image-upload">
                                            <img
                                                style={{ cursor: "pointer" }}
                                                src={profilePicture}
                                                alt="Profile"
                                                className="profile-pic-container"
                                            />
                                        </div>
                                    )}
                                    <input
                                        type="file"
                                        id="file-input"
                                        accept="image/jpeg, image/png, image/webp"
                                        style={{ display: "none", cursor: "pointer" }}
                                        onChange={handleImageUpload}
                                    />
                                </>
                            ) : (
                                <>
                                    {!profilePicture && (
                                        <img
                                            src="/ProfilePicDefault.svg"
                                            alt="Profile"
                                            className="profile-pic-container"
                                        />
                                    )}
                                    {profilePicture && (
                                        <img src={profilePicture} alt="Profile" className="profile-pic-container" />
                                    )}
                                </>
                            )}
                        </label>
                        {userId !== id && friends.includes(id) && (
                            <div className="message-and-remove-container">
                                {/* <img
									onClick={handleMessage}
									className="profile-message-button"
									src="/menuicon/003-comment.svg"
									title={`Message ${firstName}`}></img> */}
                            </div>
                        )}
                    </div>
                    <div className="additional-info">
                        <p className="name-user-profile">
                            {firstName} {lastName}
                        </p>
                        <p className="email-user-profile">{emailAddress}</p>
                        <div className="operators-list-title">
                            <h3 style={{ margin: "none" }}>Operator(s)</h3>
                        </div>
                        <div className="operators-list">
                            {licenses.map((license, index) => (
                                <div
                                    onClick={() => navigate(`/profile/${license.licenseNo}`)}
                                    style={{
                                        textDecoration: "none",
                                        textAlign: "center",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        margin: "5px 0",
                                    }}
                                    key={index}
                                    className="operator-list-item"
                                >
                                    {Array.isArray(license)
                                        ? license
                                            ? license.company
                                            : license.company
                                        : license.company}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserProfile;
